import Vue from 'vue'
import Router from 'vue-router'
import home from '../page/Home'
// import login from '../page/Login/Login'
import enterFor from '../page/EnterFor/EnterFor'
import contribute from '../page/Contribute/Contribute'
import reader from '../page/Reader/Reader'
import admin from '../page/Admin/Admin'
import user from '../page/Admin/User'
import thesisAllot from '../page/Admin/ThesisAllot'
import enterForCheck from '../page/Admin/EnterForCheck'
import teamMessage from "../page/Admin/teamMessage";
import timeManage from '../page/Admin/TimeManage'
import playerManage from '../page/Admin/PlayerManage'
import contributeManage from '../page/Admin/ContributeManage'
import noticeManage from '../page/Admin/NoticeManage'
import Instruction from '../page/Admin/Instruction'
import thesisLast from '../page/Admin/ThesisLast'
import binding from '../page/Binding/Binding'
import hotInform from '../page/Layout/HotInform'
import viewDetails from '../page/Layout/viewDetails'
import layoutDesigner from '../page/Layout/LayoutDesigner'
import QqTransition from '../page/Layout/QqTransition'
import preView from '../page/Layout/Preview'
import viewMore from '../page/Layout/ViewMore'
import {Message} from 'element-ui'
import {vuexTimeData} from '../util/vuexData'
import api from '../api'

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router)

let router = new Router({
  // mode: 'history',
  mode: 'hash',
  base: '/',
  routes: [
    {
      path: '/',
      name: 'home',
      component: home,
      meta: {
        verification: true
      },
    }, {
      path: '/enter_for',
      name: 'enterFor',
      component: enterFor,
      meta: {
        verification: true
      },
    },
    // {
    //   path: '/login',
    //   name: 'login',
    //   component: login,
    //   meta: {
    //     verification: false
    //   },
    // },
    {
      path: '/contribute',
      name: 'contribute',
      component: contribute,
      meta: {
        verification: true
      },
    }, {
      path: '/reader',
      name: 'reader',
      component: reader,
      meta: {
        verification: true
      },
    }, {
      path: '/admin',
      name: 'admin',
      component: admin,
      meta: {
        verification: true
      },
      children: [{
          path: 'user',
          name: 'user',
          component: user,
          meta: {
            verification: true
          },
        }, {
          path: 'thesis_allot',
          name: 'thesisAllot',
          component: thesisAllot,
          meta: {
            verification: true
          },
        }, {
          path: 'thesis_last',
          name: 'thesisLast',
          component: thesisLast,
          meta: {
            verification: true
          },
        }, {
          path: 'enter_for_check',
          name: 'enterForCheck',
          component: enterForCheck,
          meta: {
            verification: true
          },
        },{
          path: 'teamMessage',
          name: 'teamMessage',
          component: teamMessage,
          meta: {
            verification: true
          },
        },{
          path: 'time_manage',
          name: 'timeManage',
          component: timeManage,
          meta: {
            verification: true
          },
        }, {
          path: 'player_manage',
          name: 'playerManage',
          component: playerManage,
          meta: {
            verification: true
          },
        }, {
          path: 'contribute_manage',
          name: 'contributeManage',
          component: contributeManage,
          meta: {
            verification: true
          },
        },{
          path: 'notice_manage',
          name: 'noticeManage',
          component: noticeManage,
          meta: {
            verification: true
          },
        },
        {
          path: '/instruction',
          name: 'instruction',
          component: Instruction,
          meta: {
            verification: false
          },
        }

      ]
    },
    // {
    //   path: '/binding',
    //   name: 'binding',
    //   component: binding,
    //   meta: {
    //     verification: false
    //   },
    // },
    {
      path: '/hot_inform',
      name: 'hotInform',
      component: hotInform,
      meta: {
        verification: false
      },
    }, {
      path: '/view_details',
      name: 'viewDetails',
      component: viewDetails,
      meta: {
        verification: false
      },
    }, {
      path: '/layout_designer',
      name: 'layoutDesigner',
      component: layoutDesigner,
      meta: {
        verification: false
      },
    }, {
      path: '/qq_transition',
      name: 'QqTransition',
      component: QqTransition,
      meta: {
        verification: false
      },
    }, {
      path: '/preview',
      name: 'preView',
      component: preView,
      meta: {
        verification: false
      },
    }, {
      path: '/view_more',
      name: 'viewMore',
      component: viewMore,
      meta: {
        verification: false
      },
    }

  ],
})

/**
 * 白名单
 */
const whiteList = ['/qq_transition','/hot_inform','/view_more','instruction']


router.beforeEach((async function beForEach(to, from, next) {
  if (whiteList.includes(to.path)) {
    if (to.path === '/view_more') {
      api.login.getGameInfo().then(function (response) {
        if (response == null) {
          return null
        }
        if (response.data.code === "0") {
          let result = response.data.result
          vuexTimeData(result)
        }
      })
    }
    next()
  } else {
    let userInfo = router.app.$options.store.state.user
    if (userInfo.userToken == null || userInfo.userToken === "") {
      api.user.getUserInfo().then(function (response) {
        if (response == null) {
          userInfo.userToken = null
          userInfo.type = -1
          router.app.$options.store.state.user = userInfo;
          // routerSkip(userInfo, to, next)
          // api.login.getGameInfo().then(function (response) {
          //   if (response == null) {
          //     return null
          //   }
          //   if (response.data.code === "0") {
          //     let result = response.data.result
          //     vuexTimeData(result)
          //   }
          // })
        } else {
          let result1 = response.data.result
          userInfo = vuexToValue(result1)
          // routerSkip(userInfo, to, next)
          // api.login.getGameInfo().then(function (response) {
          //   if (response == null) {
          //     return null
          //   }
          //   if (response.data.code === "0") {
          //     //把时间存到vuex里
          //     let result = response.data.result
          //     vuexTimeData(result)
          //   }
          // })
        }
        api.login.getGameInfo().then(function (response) {
          if (response == null) {
            return null
          }
          if (response.data.code === "0") {
            let result = response.data.result
            vuexTimeData(result)
          }
          routerSkip(userInfo, to, next)
        }).catch(error =>{
          routerSkip(userInfo, to, next)
        })
      }).catch(error =>{
        userInfo.userToken = null
        userInfo.type = -1
        router.app.$options.store.state.user = userInfo;
        routerSkip(userInfo, to, next)
      })
    } else {
      routerSkip(userInfo, to, next)
    }
  }

}));

/**
 * 给VUEX赋值
 */
function vuexToValue(result) {
  let userInfo = {}
  let localStorage = window.localStorage;
  if (localStorage) {
    if (result.userToken === "" || result.userToken == null || result.userToken == undefined) {
      userInfo.userToken = localStorage.getItem('thesis-userToken');
    } else {
      localStorage.setItem('thesis-userToken', result.userToken);
    }
  }
  userInfo.userToken = result.userToken
  userInfo.userId = result.id
  userInfo.userName = result.userName
  userInfo.userTypeEnum = result.userTypeEnum
  userInfo.certificateStatus = result.certificateStatus
  userInfo.userPhone = result.userPhone
  userInfo.type = 1
  router.app.$options.store.state.user = userInfo;
  return userInfo
}

function getQuery(name) {
  let after = window.location.hash.split("?")[1];
  if (after) {
    let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
    let r = after.match(reg);
    if (r != null) {
      return decodeURIComponent(r[2]);
    } else {
      return null;
    }
  }
}

/**
 * 获取导航栏拼接的参数
 * @param name
 * @returns {string|null}
 */
function getQueryString(name) {
  let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
  let r = window.location.search.substr(1).match(reg);
  if (r != null) return decodeURI(r[2]);
  return null;
  // let after = window.location.hash.split("?")[1];
  // if (after) {
  //   let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  //   let r = after.match(reg);
  //   if (r != null) {
  //     return decodeURIComponent(r[2]);
  //   } else {
  //     return null;
  //   }
  // }
}

/**
 * 路由跳转
 * @param userInfo 用户信息
 */
function routerSkip(userInfo, to, next) {
  if(userInfo.type === -1 && to.path !== '/' ) {
    next('/')
  }
  //管理员页面
  if (to.matched[0].path === '/admin') {
    // if (userInfo.type === -1) {
    //   next({
    //     path: '/login',
    //     query: {redirect: to.fullPath} // 将跳转的路由path作为参数，登录成功后跳转到该路由
    //   })
    //   return
    // }
    if (userInfo.userTypeEnum !== 'MANAGER') {
      Message({
        showClose: true,
        message: "您没有权限!",
        type: 'error',
        duration: 2000,
      });
      return
    }
  }

  let currentTime = new Date().getTime()//当前时间
  let enterForStartTime = new Date(router.app.$options.store.state.register_enter_oneContribute_startTime).getTime()
  let enterForEndTime = new Date(router.app.$options.store.state.register_enter_oneContribute_endTime).getTime()
  //判断报名的状态
  if (to.name === 'enterFor') {
    // if (userInfo.type === -1) {
    //   next({
    //     path: '/login',
    //     query: {redirect: to.fullPath} // 将跳转的路由path作为参数，登录成功后跳转到该路由
    //   })
    //   return
    // }
    if (userInfo.userTypeEnum === 'MANAGER' || userInfo.userTypeEnum === 'REFEREE') {
      Message({
        showClose: true,
        message: "您没有权限!",
        type: 'error',
        duration: 2000,
      });
      return
    }

    if (userInfo.certificateStatus === 'NODATA') {
      let certificate= router.app.$options.store.state.certificate
      if (certificate===0) {
        Message({
          showClose: true,
          message: "报名时间(" + router.app.$options.store.state.register_enter_oneContribute_startTime + "至" + router.app.$options.store.state.register_enter_oneContribute_endTime + ")",
          type: 'error',
          duration: 2000,
        });
        next({
          path: '/',
          query: {redirect: to.fullPath}
        })
        return
      }
    }
  }

  //投稿
  if (to.name === 'contribute') {
    // if (userInfo.type === -1) {
    //   next({
    //     path: '/login',
    //     query: {redirect: to.fullPath} // 将跳转的路由path作为参数，登录成功后跳转到该路由
    //   })
    //   return
    // }
    if (userInfo.userTypeEnum === 'MANAGER' || userInfo.userTypeEnum === 'REFEREE') {
      Message({
        showClose: true,
        message: "您没有权限!",
        type: 'error',
        duration: 2000,
      });
      return
    }
    //判断一下日期
    if (userInfo.certificateStatus === 'APPROVED') {
      next();
    } else {
      let message = ""
      switch (userInfo.certificateStatus) {
        case "CERTIFICATING":
          message = "报名成功方可投稿!"
          break
        case "REFUSED":
          message = "抱歉,您报名没有通过审核!"
          break
        case "NODATA":
          message = "您还没有报名"
          break
      }
      Message({
        showClose: true,
        message: message,
        type: 'error',
        duration: 2000,
      });
      return
    }
  }

  //审稿
  if (to.name === 'reader') {
    // if (userInfo.type === -1) {
    //   next({
    //     path: '/login',
    //     query: {redirect: to.fullPath} // 将跳转的路由path作为参数，登录成功后跳转到该路由
    //   })
    //   return
    // }
    if (userInfo.userTypeEnum === 'MANAGER' || userInfo.userTypeEnum === 'PLAYER') {
      Message({
        showClose: true,
        message: "您没有权限!",
        type: 'error',
        duration: 2000,
      });
      return
    }
    //做时间判断如果没有到审核时间直接提示
    /* let curRound = router.app.$options.store.state.curRound
     let oneStartTime = new Date(router.app.$options.store.state.oneContributeCheck_startTime).getTime()
     let oneEndTime = new Date(router.app.$options.store.state.oneContributeCheck_endTime).getTime()
     let twoStartTime = new Date(router.app.$options.store.state.twoContributeCheck_startTime).getTime()
     let twoEndTime = new Date(router.app.$options.store.state.twoContributeCheck_endTime).getTime()
     if (curRound === 1) {
       if (currentTime > oneStartTime && currentTime < oneEndTime) {
       } else {
         Message({
           showClose: true,
           message: "第一阶段审核时间(" + router.app.$options.store.state.oneContributeCheck_startTime + "至" + router.app.$options.store.state.oneContributeCheck_endTime + ")",
           type: 'error',
           duration: 2000,
         });
         next({
           path: '/',
           query: {redirect: to.fullPath}
         })
         return
       }
     } else if (curRound === 2) {
       if (currentTime > twoStartTime && currentTime < twoEndTime) {
       } else {
         Message({
           showClose: true,
           message: "第二阶段审核时间(" + router.app.$options.store.state.twoContributeCheck_startTime + "至" + router.app.$options.store.state.twoContributeCheck_endTime + ")",
           type: 'error',
           duration: 2000,
         });
         next({
           path: '/',
           query: {redirect: to.fullPath}
         })
         return
       }
     }*/
  }

  // if (to.meta.verification) {
  //   if (userInfo.type !== -1) {
  //     next();
  //   } else {
  //     next({
  //       path: '/login',
  //       query: {redirect: to.fullPath} // 将跳转的路由path作为参数，登录成功后跳转到该路由
  //     })
  //   }
  // } else {
    next();
  // }
}


export default router



// WEBPACK FOOTER //
// ./src/router/index.js